'use client';

import type { LeadInput } from '@jlg-website/shared';
import type { MarketingValues } from '@/providers/marketing/campaign';

/**
 * The campaign block every form event carries. It reports the *external* marketing lead type id
 * (`leadTypeId`), not the internal one the lead row stores — `input.campaign.lead_type.id` is
 * the FK to `claim_sections`, so it cannot be reused here.
 */
function toCampaignEvent(marketing: MarketingValues) {
  return {
    id: marketing.campaignId,
    lead_score_baseline: marketing.leadScoreBaseline,
    lead_source: {
      id: marketing.leadSourceId,
    },
    lead_type: {
      id: marketing.leadTypeId,
      lead_type_name: marketing.leadTypeName,
    },
  };
}

export function QuestionsFilledOut(input: LeadInput, marketing: MarketingValues) {
  window.JLG?.analytics?.queue?.push({
    data: {
      form: {
        contact_filled_out: false,
        form_filled_out: false,
        internal_event: 'QuestionsFilledOut',
        questions_filled_out: true,
        steps: {
          count: 1,
          current: 1,
        },
        two_fa_completed: true,
      },
      session: {
        campaign: toCampaignEvent(marketing),
        form: {
          id: 1,
        },
        lead: {
          answers: input.lead.answers,
          contact: input.lead.contact,
          id: null,
          is_duplicate: null,
          is_qualified: input.lead.is_qualified,
          score: input.lead.score,
        },
        session: window.JLG?.analytics?.session?.session_id,
      },
    },
    name: 'FormEvent',
  });
}

export function ContactFilledOut(input: LeadInput, marketing: MarketingValues) {
  window.JLG?.analytics?.queue?.push({
    data: {
      form: {
        contact_filled_out: true,
        form_filled_out: true,
        internal_event: 'ContactFilledOut',
        questions_filled_out: true,
        steps: {
          count: 1,
          current: 1,
        },
        two_fa_completed: true,
      },
      session: {
        campaign: toCampaignEvent(marketing),
        form: {
          id: 1,
        },
        lead: {
          answers: input.lead.answers,
          contact: input.lead.contact,
          id: null,
          is_duplicate: input.lead.is_qualified,
          is_qualified: input.lead.is_qualified,
          score: input.lead.score,
        },
        session: window.JLG?.analytics?.session?.session_id,
      },
    },
    name: 'FormEvent',
  });
}

export function LeadCreated(leadId: number, input: LeadInput, marketing: MarketingValues) {
  window.JLG?.analytics?.queue?.push({
    data: {
      form: {
        internal_event: 'LeadCreated',
        steps: {},
      },
      session: {
        campaign: toCampaignEvent(marketing),
        form: {
          id: 1,
        },
        lead: {
          answers: input.lead.answers,
          contact: input.lead.contact,
          id: leadId,
          is_duplicate: false,
          is_qualified: input.lead.is_qualified,
          score: input.lead.score,
        },
        session: window.JLG?.analytics?.session?.session_id,
      },
    },
    name: 'FormEvent',
  });
}
